import { render, staticRenderFns } from "./SummaryClientDetails.vue?vue&type=template&id=23ef9d12"
import script from "./SummaryClientDetails.vue?vue&type=script&lang=js"
export * from "./SummaryClientDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports